module.exports = __webpack_public_path__ + "static/media/xiconn.f2817ec6.svg";